"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function getSchema(_class) {
    const validate = _1.IntegrationSchema.getSchema("#" + _class);
    if (!validate) {
        return undefined;
    }
    return validate.schema;
}
exports.getSchema = getSchema;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2dldFNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHdCQUErRDtBQUUvRCxTQUFnQixTQUFTLENBQUMsTUFBYztJQUN0QyxNQUFNLFFBQVEsR0FBRyxvQkFBaUIsQ0FBQyxTQUFTLENBQUMsR0FBRyxHQUFHLE1BQU0sQ0FBQyxDQUFDO0lBQzNELElBQUksQ0FBQyxRQUFRLEVBQUU7UUFDYixPQUFPLFNBQVMsQ0FBQztLQUNsQjtJQUVELE9BQU8sUUFBUSxDQUFDLE1BQWlDLENBQUM7QUFDcEQsQ0FBQztBQVBELDhCQU9DIn0=